"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.DisplaySize = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _BaseModule2 = require("./BaseModule");
/*
no-invalid-this: "off" is justified because the way this object is created
is a bit different than a standard object.  this is essentially a plugin to quill,
so it needs it's own standardized API to create/destroy, etc.
*/
/* eslint no-invalid-this: "off" */
var DisplaySize = exports.DisplaySize = /*#__PURE__*/function (_BaseModule) {
  (0, _inheritsLoose2.default)(DisplaySize, _BaseModule);
  function DisplaySize() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BaseModule.call.apply(_BaseModule, [this].concat(args)) || this;
    _this.onCreate = function () {
      // Create the container to hold the size display
      _this.display = document.createElement('div');

      // Apply styles
      Object.assign(_this.display.style, _this.options.displayStyles);

      // Attach it
      _this.overlay.appendChild(_this.display);
    };
    /* eslint no-empty-function: "off" */
    _this.onDestroy = function () {};
    _this.onUpdate = function () {
      if (!_this.display || !_this.img) {
        return;
      }
      var size = _this.getCurrentSize();
      _this.display.innerHTML = size.join(' &times; ');
      if (size[0] > 120 && size[1] > 30) {
        // position on top of image
        Object.assign(_this.display.style, {
          right: '4px',
          bottom: '4px',
          left: 'auto'
        });
      } else if (_this.img.style.float === 'right') {
        // position off bottom left
        var dispRect = _this.display.getBoundingClientRect();
        Object.assign(_this.display.style, {
          right: 'auto',
          bottom: "-" + (dispRect.height + 4) + "px",
          left: "-" + (dispRect.width + 4) + "px"
        });
      } else {
        // position off bottom right
        var _dispRect = _this.display.getBoundingClientRect();
        Object.assign(_this.display.style, {
          right: "-" + (_dispRect.width + 4) + "px",
          bottom: "-" + (_dispRect.height + 4) + "px",
          left: 'auto'
        });
      }
    };
    _this.getCurrentSize = function () {
      return [_this.img.width, Math.round(_this.img.width / _this.img.naturalWidth * _this.img.naturalHeight)];
    };
    return _this;
  }
  return DisplaySize;
}(_BaseModule2.BaseModule);